import axios from 'axios'

export const state = {
  users: null,
  pagination: null,
}

export const getters = {
  users: (state) => state.users,
  usersPagination: (state) => state.pagination,
}

export const mutations = {
  SET_USERS(state, users) {
    state.users = users
  },

  SET_PAGINATION(state, headers) {
    state.pagination = {
      currentPage: parseInt(headers['x-current-page']),
      nextPage: parseInt(headers['x-next-page']),
      prevPage: parseInt(headers['x-prev-page']),
      totalItems: parseInt(headers['x-total-items']),
      totalPages: parseInt(headers['x-total-pages']),
      perPage: parseInt(headers['x-per-page']),
    }
  },
}

export const actions = {
  fetchAllUsers({ commit, state, rootState }, payload) {
    return axios
      .get('/api/users', {
        params: payload,
      })
      .then((response) => {
        const users = response.data
        commit('SET_USERS', users)
        commit('SET_PAGINATION', response.headers)
        return users
      })
  },

  viewUser({ commit, state, rootState }, id) {
    return axios.get(`/api/users/${id}`).then((response) => response.data)
  },

  createUser({ commit, state, rootState }, payload) {
    return axios.post('/api/users', payload)
  },

  updateUser({ commit, state, rootState }, payload) {
    return axios.put(`/api/users/${payload.id}`, payload)
  },

  deleteUser({ commit, state, rootState }, id) {
    return axios.delete(`/api/users/${id}`)
  },
}
